import { render, staticRenderFns } from "./regionReportList.vue?vue&type=template&id=51215896&scoped=true"
import script from "./regionReportList.vue?vue&type=script&lang=js"
export * from "./regionReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51215896",
  null
  
)

export default component.exports